import { Form, Input } from 'antd'
import React from 'react'

const FormulaIdField: React.FC = () => {
  return (
    <Form.Item name="id" style={{ display: 'none' }}>
      <Input />
    </Form.Item>
  )
}

export default FormulaIdField
